import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('more', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "24",
    r: "3",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "3",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "36",
    cy: "24",
    r: "3",
    fill: props.colors[0]
  }));
});